<template>
  <div class="page">
    <box fill>
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="类型" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="pagination.logType">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="操作人" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="pagination.logUser">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="内容" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="pagination.logContent">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
              查询
            </el-button>
            <el-button class="btn-t-delete" @click="resetData()">
              重置
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
      <el-divider></el-divider>
      <plabel text="日志">
        <el-button
          v-authority="'BACK_MENU8_M4_B1'"
          class="btn-t-edit"
          @click="(add_or_edit = true), (editBoxShow = true)"
          >新增</el-button
        >
      </plabel>
      <!-- 展示 -->
      <h-table
        :headerCellStyle="headerCellStyle"
        style="flex: 1"
        @pageChange="getAuxiMaterialData"
        :data="mainData"
        pagination
        :nowPage.sync="pagination.pageNum"
        :pageSize.sync="pagination.pageSize"
        :total.sync="pagination.total"
      >
        <!-- <el-table-column prop="logId" label="序号" /> -->
        <el-table-column prop="logType" label="类型" />
        <el-table-column prop="logContent" label="内容" width="600px" :show-overflow-tooltip="true"/>
        <el-table-column prop="logUser" label="操作人" />
        <el-table-column prop="createTime" label="创建时间" />
        <el-table-column prop="updateTime" label="修改时间" />
      </h-table>
    </box>
  </div>
</template>

<script>
export default {
  name: "Log",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      // 分页
      pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        logType: "",
        logUser: "",
        logContent:"",
      },
      // 页面展示主信息
      mainData: [],
      // 输入框延时加载
      isSetTimeout: null,
    };
  },
  watch: {
    pagination: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout)
        this.isSetTimeout = setTimeout(() => {
          this.getAuxiMaterialData(newVal);
        },1000)
      },
      deep: true,
    },
  },
  methods: {
    //获取数据
    getAuxiMaterialData () {
      this.$http
        .request({
          url: "/api/log/getLogData",
          method: "GET",
          showLoading: true,
          params: this.pagination,
        })
        .then((resp) => {
          if (resp.status == 100) {
            // console.log(resp.data.list);
            this.mainData = resp.data.list || [];
            this.pagination.total = resp.data.total;
          }
        })
        .catch((error) => {});
    },

    //重置
    resetData() {
      this.pagination = {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        logType: "",
        logUser: "",
      };
      this.getAuxiMaterialData();
    },
  },
  activated(){
    /* 获取首页的数据 */
    this.getAuxiMaterialData();
  },
};
</script>

<style scoped>
</style>